var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('prism-editor', {
    attrs: {
      "highlight": _vm.highlighter
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', _vm.code);
      }
    },
    model: {
      value: _vm.code,
      callback: function ($$v) {
        _vm.code = $$v;
      },
      expression: "code"
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }